module.exports = __webpack_public_path__ + "assets/thumbs_down.77301a1da02c99c451c1649ed9f637437389fc61a874e8f2780690c30c5f3c53.png";